"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeCoverView = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../../commonFunctions");
var InfoModal_1 = require("../../../../components/modals/InfoModal");
var react_router_dom_1 = require("react-router-dom");
var journey_services_1 = require("@athena-portal/journey-services");
var moment = require("moment");
var SectionPanelTags_1 = require("../../../../widgets/SectionPanelTags");
var HomeCoverView = /** @class */ (function (_super) {
    __extends(HomeCoverView, _super);
    function HomeCoverView(props) {
        var _this = _super.call(this, props) || this;
        _this.renderExcessExplained = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "font-weight-extra-light" }, "This is the amount you must pay towards a claim."),
                React.createElement("p", { className: "font-weight-extra-light" }, "Please note: if you choose a higher excess, some cover (such as \u2018money\u2019) may no longer provide benefit as the excess you\u2019d pay would exceed the value of your claim. For example, under our Bronze product we offer up to \u00A3250 for money in the home, however if you chose an excess of \u00A3500 your excess would be more than the limit provided.")));
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var allOthersClaim = parseInt(event.target.value, 10);
            if (allOthersClaim === 500) {
                _this.setState({
                    showWaringPopup: true
                });
            }
            _this.setState({
                allOthersClaim: allOthersClaim
            });
            journey_services_1.ObjectManipulator.setField("annualHomeExcesses.allOtherClaims", _this.props.interaction, allOthersClaim);
            _this.executeNativeEvent(event);
        };
        _this.handleChangeAddressRedirect = function (e) {
            var interactionProcess = _this.props.interaction.process;
            var uistate = _this.props.interaction.uistate;
            var allowAddressChange = uistate.minMtaStartDate ? moment(uistate.maxMtaStartDate) >= moment(uistate.minMtaStartDate) : true;
            if (interactionProcess === services_1.INTERACTION_PROCESS_RENEWAL) {
                e.preventDefault();
                void _this.props.engine.navigate("propertyDetails", false);
            }
            else {
                !allowAddressChange && e.preventDefault();
            }
        };
        return _this;
    }
    HomeCoverView.prototype.render = function () {
        var interaction = this.props.interaction;
        var realEstate = this.props.interaction.realEstate[0];
        var annualHomeExcesses = interaction.annualHomeExcesses;
        var buildings = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "BUILDINGS_LIMIT", interaction);
        var contents = (0, commonFunctions_1.getCoverLimitAmount)("BUILDINGS_CONTENTS", "CONTENTS_LIMIT", interaction);
        var quoteTier = this.props.interaction.coverTier;
        return (React.createElement("div", { className: "section-panel annual-home-mta align-items-center page-contents-inner" },
            React.createElement(SectionPanelTags_1.Section, { className: "insured-address-section" },
                React.createElement("img", { className: "home-image grid-row-1-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-icon.png"), alt: "Home icon" }),
                React.createElement("img", { className: "tier-icon top-right-image", src: this.tierImage(quoteTier), alt: "Home tier" }),
                React.createElement(SectionPanelTags_1.SectionHeading, null, this.tierDetail(quoteTier)),
                React.createElement(SectionPanelTags_1.SectionHeading, null, "Insured address"),
                React.createElement(SectionPanelTags_1.SectionContents, null,
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement("div", null, realEstate.address.fullAddress),
                        this.renderChangeAddressButton()),
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement(SectionPanelTags_1.DetailKey, null, "Buildings cover:"),
                        React.createElement(SectionPanelTags_1.DetailValue, null,
                            "up to ",
                            (0, commonFunctions_1.getAmountToDisplay)(buildings))),
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement(SectionPanelTags_1.DetailKey, null, "Contents cover:"),
                        React.createElement(SectionPanelTags_1.DetailValue, null,
                            "up to ",
                            (0, commonFunctions_1.getAmountToDisplay)(contents))))),
            React.createElement(SectionPanelTags_1.Section, { className: "excess-section" },
                React.createElement(SectionPanelTags_1.SectionHeading, { className: "position-relative mb-4 d-flex" },
                    "Excesses",
                    React.createElement(InfoModal_1.InfoModal, { title: "Excess", showArrow: false, className: "ml-3" }, this.renderExcessExplained())),
                React.createElement(SectionPanelTags_1.SectionContents, null,
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement(SectionPanelTags_1.DetailKey, null, "Subsidence, landslip or heave:"),
                        React.createElement(SectionPanelTags_1.DetailValuePrice, null, (0, commonFunctions_1.getAmountToDisplay)(annualHomeExcesses.subsidence))),
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement(SectionPanelTags_1.DetailKey, null, "Escape of water:"),
                        React.createElement(SectionPanelTags_1.DetailValuePrice, null, (0, commonFunctions_1.getAmountToDisplay)(annualHomeExcesses.escapeOfWater))),
                    React.createElement(SectionPanelTags_1.Detail, null,
                        React.createElement(SectionPanelTags_1.DetailKey, null, "Flood:"),
                        React.createElement(SectionPanelTags_1.DetailValuePrice, null, (0, commonFunctions_1.getAmountToDisplay)(annualHomeExcesses.flood))),
                    React.createElement(SectionPanelTags_1.Detail, { className: "d-flex align-items-center" },
                        React.createElement(SectionPanelTags_1.DetailKey, null, "All other claims:"),
                        React.createElement("div", { className: "detail-value d-flex justify-content-center" },
                            React.createElement("select", { id: this.props.question.name, className: "form-control voluntary-excess-picker__dropdown font-weight-semi-bold", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, disabled: true }, this.renderOptionsList(annualHomeExcesses.allOtherClaims))))))));
    };
    HomeCoverView.prototype.tierImage = function (tier) {
        switch (tier) {
            case services_1.BRONZE_TIER:
                return "/".concat(services_1.resourcesHelper.THEME, "/img/AZ-Bronze.png");
            case services_1.SILVER_TIER:
                return "/".concat(services_1.resourcesHelper.THEME, "/img/AZ-Silver.png");
            default:
                return "/".concat(services_1.resourcesHelper.THEME, "/img/AZ-Gold.png");
        }
    };
    HomeCoverView.prototype.tierDetail = function (tier) {
        switch (tier) {
            case services_1.BRONZE_TIER:
                return "Allianz Bronze Cover";
            case services_1.SILVER_TIER:
                return "Allianz Silver Cover";
            default:
                return "Allianz Gold Cover";
        }
    };
    HomeCoverView.prototype.changeAddressJourneyLink = function (interactionProcess) {
        switch (interactionProcess) {
            case services_1.INTERACTION_PROCESS_MTA:
                return "/journey/init/product/AnnualHomeInsurance/process/mtaChangeAddress/preset/".concat(this.props.interaction.uistate.relativeInteractionId);
            case services_1.INTERACTION_PROCESS_RENEWAL:
                return "#";
            default:
                return "/journey/show/product/AnnualHomeInsurance/process/mtaSupportPortalAnnualHomeChangeAddress/preset/".concat(this.props.interaction.uistate.relativeInteractionId);
        }
    };
    HomeCoverView.prototype.renderOptionsList = function (allOthersClaim) {
        var options = [];
        for (var i = 150; i <= 500; i = i + 50) {
            options.push(React.createElement("option", { key: i, selected: allOthersClaim === i, value: i }, (0, commonFunctions_1.getAmountToDisplay)(i)));
        }
        return options;
    };
    HomeCoverView.prototype.renderChangeAddressButton = function () {
        var interactionProcess = this.props.interaction.process;
        var uistate = this.props.interaction.uistate;
        var allowAddressChange = uistate.minMtaStartDate ? moment(uistate.maxMtaStartDate) >= moment(uistate.minMtaStartDate) : true;
        var changeAddressJourneyLink = this.changeAddressJourneyLink(interactionProcess);
        return (React.createElement("div", { className: "d-flex" },
            React.createElement(react_router_dom_1.Link, { className: "text-decoration-none", to: changeAddressJourneyLink, onClick: this.handleChangeAddressRedirect },
                React.createElement("button", { type: "button", className: allowAddressChange ? "btn btn-primary mb-3 w-auto mt-4" : "btn btn-disabled btn-primary mb-3 w-auto mt-4" }, "Change address"))));
    };
    return HomeCoverView;
}(plugin_journey_1.WidgetBase));
exports.HomeCoverView = HomeCoverView;
//# sourceMappingURL=HomeCoverView.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/mta/HomeCoverView.js
// module id = 3706
// module chunks = 0